import {TerminalLockIcon} from '@github-ui/custom-icons/TerminalLockIcon'

import styles from './CliPrivateIcon.module.css'

interface CliPrivateIconProps {
  showConnectedDot?: boolean
}

export function CliPrivateIcon({showConnectedDot = false}: CliPrivateIconProps) {
  const ariaLabel = showConnectedDot ? 'Private session connected' : 'Private remote session'

  return (
    <span className={styles.wrapper} role="img" aria-label={ariaLabel}>
      <TerminalLockIcon />
      {showConnectedDot && <span data-testid="connected-dot" className={styles.connectedDot} aria-hidden="true" />}
    </span>
  )
}
